import { phoneMaskList } from './phoneMask';

export function phoneMask(value: string, setCountry: (country: string) => void) {
  let matrix = '+###############';

  const country = getCountryByPhone(value);

  if (country) {
    setCountry(country.emoji);
    matrix = country.code;
  }

  let i = 0;
  const val = value.replace(/\D/g, '');

  return matrix.replace(/(?!\+)./g, function (a) {
    return /[#\d]/.test(a) && i < val.length ? val.charAt(i++) : i >= val.length ? '' : a;
  });
}

export function validatePhoneNumber(phoneNumber: string) {
  const country = getCountryByPhone(phoneNumber);

  if (!country) {
    return false;
  }

  return phoneNumber.length === country.code.length;
}

export function getCountryByPhone(phoneNumber: string) {
  for (const item of phoneMaskList) {
    const code = item.code.replace(/[\s#]/g, '');
    const phone = phoneNumber.replace(/[\s#-)(]/g, '');

    if (phone.includes(code)) {
      return item;
    }
  }
}
